exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#write-in[data-v-01603ff2]{min-height:150px;justify-content:center}#write-in input[data-v-01603ff2]{border-radius:2px;max-width:25px}#write-in .row[data-v-01603ff2]{justify-content:center}.text[data-v-01603ff2]{display:flex}.non-alphanumeric[data-v-01603ff2]{background:#eee}", ""]);

// exports
